import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Injectable({
  providedIn: "root"
})
export class SeoService {
  constructor(private title: Title, private meta: Meta) { }
  updateTags(title, description) {
    debugger
    this.title.setTitle(title)
    this.meta.updateTag({ property: 'og:title', content: title })
    if (description == null || description == undefined || description == "") {
      this.meta.updateTag({ name: 'description', content: title })
      this.meta.updateTag({ property: 'og:description', content: title })
    } else {
      this.meta.updateTag({ name: 'description', content: description })
      this.meta.updateTag({ property: 'og:description', content: description })
    }
  }
  resetTags() {
    this.title.setTitle("NanoVisionTech")
    this.meta.updateTag({ name: 'description', content: "NanoVisionTech is a full-service multi-vendor technology partner offering quality network products affordably with a life-time warranty." })
    this.meta.updateTag({ name: 'og:title', content: "NanoVisionTech | Buy Computer Accessories Online" })
    this.meta.updateTag({ name: 'og:description', content: "NanoVisionTech is a full-service multi-vendor technology partner offering quality network products affordably with a life-time warranty." })
  }
}